var map = {
	"./reviewer1.svg": 282,
	"./reviewer2.svg": 136,
	"./reviewer3.svg": 781,
	"./reviewer4.svg": 380,
	"./reviewer5.svg": 769,
	"./reviewer6.svg": 320
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;